import { apiErrorHandler } from '@/services/api'
import { isObject, objectToCamelCase, objectToSnakeCase } from '@thinknimble/tn-utils'
import { ApiFilter, ModelAPI } from '@thinknimble/tn-models'
import { apiClient } from '@/services/client'
import store from '@/store'

// API Endpoints
const LOGIN_ENDPOINT = '/login/'
const REGISTRATION_ENDPOINT = '/register/'
const USERS_ENDPOINT = '/users/'
const PASSWORD_RESET_ENDPOINT = `${USERS_ENDPOINT}password/reset/confirm/`
const PASSWORD_CHANGE_ENDPOINT = `${USERS_ENDPOINT}password/reset/change/`
const PASSWORD_RESET_EMAIL_ENDPOINT = `${USERS_ENDPOINT}password/reset/link/`

export default class UserAPI extends ModelAPI {
  /**
   * ModelAPI contains methods for list and create (overridden here) and the FILTERS_MAP
   * You may override any of these methods by statically defining them here
   * e.g static FILTERS_MAP={...UserAPI.FILTERS_MAP, <FITERS>}
   *      list({ filters = {}, pagination = {} }){
   *
   * }
   */

  get client() {
    return apiClient()
  }

  static ENDPOINT = USERS_ENDPOINT

  login(d) {
    const data = { email: d.email.toLowerCase(), password: d.password }
    const promise = apiClient()
      .post(LOGIN_ENDPOINT, data)
      .catch(
        apiErrorHandler({ apiName: 'UserAPI.login', enable400Alert: false, enable500Alert: false }),
      )
    return promise
  }

  logout() {
    store.commit('LOGOUT_USER')
  }

  registerUser(registerForm) {
    const data = registerForm

    return this.client
      .post(REGISTRATION_ENDPOINT, this.cls.toAPI(data))
      .then(response => response.data)
      .then(data => this.cls.fromAPI(data))
      .catch(
        apiErrorHandler({
          apiName: 'Register User',
          enable400Alert: true,
          enable500Alert: true,
        }),
      )
  }

  updateUser(id, data) {
    let formData = new FormData()
    let file = data['profilePhoto']
    formData.append('first_name', data['firstName'])
    formData.append('last_name', data['lastName'])
    if (file && isObject(file)) {
      formData.append('profile_photo', data['profilePhoto'])
    }

    const promise = apiClient()
      .patch(UserAPI.ENDPOINT + `/${id}/`, formData)
      .catch(apiErrorHandler({ apiName: 'UserAPI.update' }))
    return promise
  }

  requestPasswordReset(email) {
    const url = `${PASSWORD_RESET_EMAIL_ENDPOINT}${email.toLowerCase()}/`
    const obj = {
      email: email,
    }

    return this.client
      .get(url, obj)
      .then(response => objectToCamelCase(response))
      .catch(
        apiErrorHandler({
          apiName: 'Request Password Reset API',
        }),
      )
  }

  resetPassword(formVal) {
    const url = `${PASSWORD_RESET_ENDPOINT}${formVal.uid}/${formVal.token}/`
    const data = {
      password: formVal.password,
    }
    return this.client
      .post(url, data)
      .then(response => this.cls.fromAPI(response.data))
      .catch(e => {
        console.log(e)
        apiErrorHandler({ apiName: 'API error' })
      })
  }
}
